import styled from 'styled-components'

import { FlowTitle } from '../../styles'

export const StyledFlowReasons = {
  Title: styled(FlowTitle)`
    margin-bottom: 24px;
  `,
  Content: styled.div`
    padding-bottom: 88px;
  `,
}
